/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Cells config for SettingsAutoReports table
 *
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.3.0
 */

import { EColumnCell, EColumnFilter } from '../../../../../../components/Table/types/columnTypes';
import { ESettingsAutoReportsField } from './settingsAutoReportsTableTypes';

export const SettingsAutoReportsCellConfig = {
    [ESettingsAutoReportsField.DESCRIPTION]: 150,
    [ESettingsAutoReportsField.ORDER_ATTR_TYPE]: 150,
    [ESettingsAutoReportsField.PERIOD_TYPE]: 150,
    [ESettingsAutoReportsField.REPORT_FORMAT]: 150,
    [ESettingsAutoReportsField.START_TIME]: 150,
    [ESettingsAutoReportsField.REPORT_NAME]: 150,
    [ESettingsAutoReportsField.REMOVE]: 150,
}

export const getSettingsAutoReportsColumnFilterType = (name: string): string => {
    switch (name) {
        case ESettingsAutoReportsField.REPORT_NAME:
        case ESettingsAutoReportsField.PERIOD_TYPE:
        case ESettingsAutoReportsField.ORDER_ATTR_TYPE:
        case ESettingsAutoReportsField.REPORT_FORMAT:
            return EColumnFilter.filterSelect;
        case ESettingsAutoReportsField.START_TIME:
            return EColumnFilter.filterTime;
        case ESettingsAutoReportsField.DESCRIPTION:
            return EColumnFilter.filterSearchInput;
        case ESettingsAutoReportsField.REMOVE:
        default:
            return '';
    }
}

export const getSettingsAutoReportsGetColumnCellType = (name: ESettingsAutoReportsField): EColumnCell => {
    switch (name) {
        case ESettingsAutoReportsField.REPORT_NAME:
            return EColumnCell.linkSettingsAutoReports;
        case ESettingsAutoReportsField.REMOVE:
            return EColumnCell.removeAutoReport;
        case ESettingsAutoReportsField.PERIOD_TYPE:
            return EColumnCell.schedule;
        case ESettingsAutoReportsField.START_TIME:
            return EColumnCell.timeCell;
        case ESettingsAutoReportsField.ORDER_ATTR_TYPE:
        case ESettingsAutoReportsField.REPORT_FORMAT:
            return EColumnCell.textDictionary;
        case ESettingsAutoReportsField.DESCRIPTION:
        default:
            return EColumnCell.text;
    }
}
